import { useCallback, useEffect, useState } from 'react';
import { api } from '../lib/api';

async function fetchList() {
  try {
    const { data } = await api.get('/highlights');
    return data.highlights || [];
  } catch (err) {
    console.error('highlights fetch failed', err);
    return [];
  }
}

export function useHighlights() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    const list = await fetchList();
    setItems(list);
  }, []);

  useEffect(() => {
    let active = true;
    fetchList().then((list) => {
      if (active) {
        setItems(list);
        setLoading(false);
      }
    });
    return () => {
      active = false;
    };
  }, []);

  return { items, loading, refetch, setItems };
}
